import PropTypes from "prop-types"
import styled from "styled-components"

const StyledAttributeValue = styled.span`
  font-family: ${({ theme }) => theme.fontFamily.geberitRg};
  font-style: normal;
  font-size: 14px;
`

const AttributeValue = ({ children }) => {
  return <StyledAttributeValue>{children}</StyledAttributeValue>
}

export default AttributeValue
AttributeValue.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}
